import { commonFilter } from './filter';

export const CompetitorsAdCreativesPoint = {
  pageName: 'Ad Creatives',
  pageId: '25106',
  pagePath: '/marketing/CompetitorsAdCreatives',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    // Segment 切换按钮（Ads/Creatives）
    TypeSegment: {
      buttonId: '2510601',
    },
    // 下载按钮
    Download: {
      buttonId: '2510602',
    },
    // 素材封面点击
    AdCover: {
      buttonId: '2510603',
    },
    // 素材标题点击
    AdTitle: {
      buttonId: '2510604',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};
